<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card" style="height: calc(100vh - 200px);position: relative;">
					<div class="detailBox">
						<p class="logo"><img :src="settings.apiBaseImg+list.logo" alt=""></p>
						<p class="name">{{list.title}}</p>
						<!-- <p class="desc"><span>公司介绍:</span>{{list.description}}</p> -->
						<!-- <p class="contentBox"><span>详情:</span> -->
						<p class="detail" v-html="list.content"></p>
						</p>
						<p class="qrcode">
							<img :src="settings.apiBaseImg+list.qrcode" alt=""><br />
							<span>了解更多</span>
						</p>
					</div>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import qs from 'qs'
export default {
  data () {
    return {
      list: []
    }
  },
  created () {
    this.getDetail(this.$route.query.id)
  },
  methods: {
    getDetail (id) {
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/application/detail',
        params: {
          id: id
        }
      }).then((res) => {
        if (res.data.status == 200) {
          console.log(res.data)
          this.list = res.data.data
        } else {
          obj.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
.detailBox {
  width: 60%;
  margin: 0 auto;
}

.detailBox .logo {
  width: 100%;
  height: 133px;
  text-align: center;
}

.detailBox .logo img {
  width: auto;
  height: 100%;
}

.detailBox .name {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  text-align: center;
  margin: 40px 0 70px 0;
}

.detailBox .desc span {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  width: 15%;
  display: inline-block;
  text-align: right;
}

.contentBox span {
  width: 15%;
  float: left;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: right;
}

.detailBox .detail {
  width: 100%;
  /* float: left; */
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #4d4d4d;
  line-height: 35px;
}

.detailBox .desc {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #4d4d4d;
}

.qrcode {
  width: 100%;
  height: auto;
  text-align: center;
  margin-top: 120px;
}

.qrcode img {
  width: 150px;
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/bullet/bulletDetail.vue